import React from 'react';

type Props = {
  className?: string;
  width?: string;
  height?: string;
  fill?: string;
  stroke?: string;
};

const Star2: React.FC<Props> = ({ className, width = '19', height = '19', fill = 'none', stroke = '#0B1215' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 19 19" fill={fill}>
    <path
      d="M9.50016 1.58301L11.9464 6.53884L17.4168 7.33842L13.4585 11.1938L14.3927 16.6405L9.50016 14.0676L4.60766 16.6405L5.54183 11.1938L1.5835 7.33842L7.05391 6.53884L9.50016 1.58301Z"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Star2;
